import type { IconData } from '@stacksjs/iconify-core'

export const bj4x3: IconData = {
  "body": "<defs><clipPath id=\"SVGwQJ26ddR\"><path fill=\"gray\" d=\"M67.6-154h666v666h-666z\"/></clipPath></defs><g clip-path=\"url(#SVGwQJ26ddR)\" transform=\"matrix(.961 0 0 .7207 -65 111)\"><g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#319400\" d=\"M0-154h333v666H0z\"/><path fill=\"#ffd600\" d=\"M333-154h666v333H333z\"/><path fill=\"#de2110\" d=\"M333 179h666v333H333z\"/></g></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default bj4x3
